/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const EffectsIcon = ({ width = 24, height = 24, hidden = false, title = 'Effects' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m17.80859,7.21973c-.29395-.29395-.76855-.29199-1.06055,0l-3.00342,3.00464-1.55811-2.83569c-.13184-.23926-.38379-.38867-.65723-.38867h-4.05493l.5686-1.84473c.00293-.01758.36426-1.71191,1.50488-2.38184.54688-.32129,1.19336-.35742,1.97363-.11035.39648.12207.81641-.09668.94141-.49023.12402-.39551-.0957-.81641-.49023-.94141-1.19629-.375-2.27148-.29004-3.19336.25391-1.71777,1.01562-2.1875,3.27734-2.18848,3.2998l-.68335,2.21484h-2.19263c-.41406,0-.75.33594-.75.75s.33594.75.75.75h1.72998l-2.93994,9.5293c-.12207.39551.09961.81543.49609.9375.07324.02246.14746.0332.2207.0332.32031,0,.61719-.20703.7168-.5293l3.07349-9.9707h4.07397l1.55444,2.8291-3.3894,3.39062c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33887.21973.53027.21973.19238,0,.38379-.07324.53027-.21973l3.08105-3.08228,1.60059,2.91333c.13672.24805.39355.38867.6582.38867.12207,0,.24609-.0293.36035-.09277.36328-.19922.49512-.65527.2959-1.01855l-1.81079-3.29541,3.31177-3.31299c.29297-.29297.29297-.76758,0-1.06055Z"
      fill="currentColor"
    />
  </svg>`;
};
